import React, {Fragment, useMemo, useState} from 'react';
import { useSelector, useDispatch } from 'react-redux';
import constants from '../constants';
import { translate } from '../Services/translation';
import InputField from './InputField';
import { setShowAlternativeAddress, setBillingNote } from '../Actions/Checkout.action';
import Button from './Button';

const getCountry = (address) => {
    const addressCountry = constants.countries
        ? constants.countries.find(
            (country) => country.value === address.country
        )
        : null;
    return addressCountry ? addressCountry.text : address.country;
};

const CheckoutBusinessCustomerInfo = ({
    onChange,
    onSave,
    onCompanyAddressChange,
    valueForm,
    isEditingAddress,
}) => {
    const dispatch = useDispatch();
    const { payload, errors = {} } = useSelector((state) => state.checkout);
    const { companyAddresses = [], companyName, authenticated, billingNote = "" } = payload;
    const { alternativeAddress = {} } = valueForm;

    const [companyNamePayloadValue, setCompanyNamePayloadValue ]= useState(companyName)

    const input = (
        cssClass,
        stateKey,
        id,
        autoComplete = 'on',
        type = 'text',
        overrideValue = ''
    ) => {
        var value = overrideValue == '' ? (valueForm[stateKey] || {})[id] || '' : overrideValue;
        return <InputField
            cssClass={value == '' ? cssClass : cssClass + " form__input-validated"}
            id={`${stateKey}-${id}`}
            name={`${stateKey}-${id}`}
            autoComplete={autoComplete}
            disabled={!authenticated}
            value={value}
            onChange={(value) => onChange(stateKey, id, value)}
            label={translate(`checkout.customerinfo.${id.toLowerCase()}`)}
            errors={errors}
            type={type}
        />
    };

    const alternativeInput = (
        cssClass,
        stateKey,
        id,
        autoComplete = 'on',
        placeholder = null,
        type = 'text',
        maxLength = 200
    ) => {
        var value = (valueForm[stateKey] || {})[id] || '';
        return <InputField
            cssClass={value == '' ? cssClass : cssClass + " form__input-validated"}
            id={`${stateKey}-${id}`}
            name={`${stateKey}-${id}`}
            autoComplete={autoComplete}
            value={value}
            onChange={(value) => onChange(stateKey, id, value)}
            label={translate(`checkout.customerinfo.${id.toLowerCase()}`)}
            errors={errors}
            placeholder={placeholder}
            type={type}
            maxLength={maxLength}
        />
    };
    const selectedAddress = useMemo(() => {
        return valueForm.selectedCompanyAddressId && companyAddresses
            ? companyAddresses.find(
                (address) =>
                    address.systemId === valueForm.selectedCompanyAddressId
            )
            : null;
    }, [valueForm.selectedCompanyAddressId, companyAddresses]);

    return (
        <div className="row checkout-info__container checkout-info__container--address">
            {(
                <Fragment>
                    <div className="small-12 medium-6 columns">
                        <div className="row-inner">
                            <div className="small-12 columns">
                                <label
                                    className="form__label"
                                    htmlFor="address"
                                >
                                    {translate('checkout.customerinfo.address')}
                                </label>
                                <select
                                    className="form__input"
                                    value={valueForm.selectedCompanyAddressId || ''}
                                    disabled={!authenticated}
                                    onChange={(event) => {
                                        var address = companyAddresses.find((address) => address.systemId === event.target.value);
                                        onCompanyAddressChange(event.target.value, address.country);
                                        // houseExtension is billingNote.
                                        dispatch(setBillingNote(address.houseExtension))
                                        onChange("customerDetails", "address", address.address)
                                        onChange("customerDetails", "zipCode", address.zipCode)
                                        onChange("customerDetails", "city", address.city)
                                        }
                                    }
                                >
                                    {companyAddresses &&
                                        companyAddresses.map((address) => (
                                            <option
                                                value={address.systemId}
                                                key={`companyAddress-${address.systemId}`}
                                            >{address.systemId == '00000000-0000-0000-0000-000000000000' ? address.address2 :  (address.houseExtension ? `${address.houseExtension} -  `: '') + `${address.address}, ${address.zipCode}, ${address.city}`}</option>
                                        ))}
                                </select>
                                {errors['selectedCompanyAddressId'] && (
                                    <span
                                        className="form__validator--error form__validator--top-narrow"
                                        data-error-for="selectedCompanyAddressId"
                                    >
                                        {errors['selectedCompanyAddressId'][0]}
                                    </span>
                                )}
                            </div>
                        </div>

                        <div className="row-inner">
                            <div className={`${billingNote && billingNote != '' ? 'form__input-validated ' : ""} small-12 columns`}>
                                <span className="checkout-info__summary--extra-info">{translate('code.checkout.order.billingnote')}</span>
                                <input
                                    className="form__input checkout-info__summary--extra-info-input"
                                    value={billingNote}
                                    onChange={(event) => dispatch(setBillingNote(event.target.value))}
                                ></input>
                                {errors["payload-billingNote"] && (
                                    <span
                                        className="form__validator--error form__validator--top-narrow"
                                        data-error-for={"payload-billingNote"}
                                    >
                                        {errors["payload-billingNote"][0]}
                                    </span>
                                )}
                            </div>
                        </div>
                        <div className="row-inner">
                            {input(
                                'small-6 columns',
                                'customerDetails',
                                'firstName',
                                'billing given-name'
                            )}

                            {input(
                                'small-6 columns',
                                'customerDetails',
                                'lastName',
                                'billing family-name'
                            )}
                        </div>
                        <div className="row-inner">
                            {input(
                                'small-6 columns',
                                'customerDetails',
                                'phoneNumber',
                                'billing tel',
                                'tel'
                            )}

                            {input(
                                'small-6 columns',
                                'customerDetails',
                                'companyName',
                                'organization',
                                'text',
                                valueForm && valueForm['customerDetails'] && valueForm['customerDetails']['companyName'] && valueForm['customerDetails']['companyName'] != ''
                                    ? (valueForm['customerDetails'] || {})['companyName']
                                    : companyNamePayloadValue
                            )}
                        </div>

                        {selectedAddress && (
                            <Fragment>
                                <div className="row-inner address-input">
                                    {input(
                                        'small-12 columns',
                                        'customerDetails',
                                        'address',
                                        'billing street-address',
                                        'text',
                                        valueForm && valueForm['customerDetails'] && valueForm['customerDetails']['address'] && valueForm['customerDetails']['address'] != ''
                                            ? (valueForm['customerDetails'] || {})['address']
                                            : selectedAddress.address

                                    )}
                                </div>

                                <div className="row-inner">
                                    {input(
                                        'small-6 columns',
                                        'customerDetails',
                                        'zipCode',
                                        'billing postal-code',
                                        'text',
                                        valueForm && valueForm['customerDetails'] && valueForm['customerDetails']['zipCode'] && valueForm['customerDetails']['zipCode'] != ''
                                            ? (valueForm['customerDetails'] || {})['zipCode']
                                            : selectedAddress.zipCode
                                    )}

                                    {input(
                                        'small-6 columns',
                                        'customerDetails',
                                        'city',
                                        'billing address-level2',
                                        'text',
                                        valueForm && valueForm['customerDetails'] && valueForm['customerDetails']['city'] && valueForm['customerDetails']['city'] != ''
                                            ? (valueForm['customerDetails'] || {})['city']
                                            : selectedAddress.city
                                    )}
                                </div>
                            </Fragment>
                        )}
                    </div>

                    <div className="small-12 medium-6 columns">
                        <div className="row-inner">

                            <Button
                                title={translate('code.checkout.address.add.new')}
                                isLink={true}
                                type="submit"
                                className="add-new-address-link"
                                onClick={(event) =>
                                {
                                    onCompanyAddressChange(
                                                '00000000-0000-0000-0000-000000000000',
                                                companyAddresses.find(
                                                    (address) =>
                                                        address.systemId ==
                                                        '00000000-0000-0000-0000-000000000000'
                                                ).country
                                            );
                                    // houseExtension is billingNote.
                                    dispatch(setBillingNote(""))
                                    onChange("customerDetails", "address", "")
                                    onChange("customerDetails", "zipCode", "")
                                    onChange("customerDetails", "city", "")
                                    onChange("customerDetails", "firstName", "")
                                    onChange("customerDetails", "lastName", "")
                                    onChange("customerDetails", "phoneNumber", "")
                                    onChange("customerDetails", "companyName", "")
                                    setCompanyNamePayloadValue("")
                                }
                                }
                            />
                            {/*onClick={placeOrder}*/}
                            {/*    <div className="small-12 columns form_input">#L�gg till ny</div>*/}
                        </div>
                    </div>
                </Fragment>
            )}
        </div>
    );
};

export default CheckoutBusinessCustomerInfo;
export { getCountry };
